// src/components/kuestion/shared/AppRail.jsx
//
// The icon rail from the web mockup: brand mark on top, one icon per section
// (title + aria-label carry the name), log out pinned to the bottom. On
// narrow screens it becomes a bottom bar with the label under the icon.
import React from 'react';
import { Mark } from './Bits';
import { LogoutIcon, BookIcon } from './Icons';
import { TourBell } from './Tour';
import { kq } from '../../../config/routes';

export default function AppRail({ items, active, onGo, onLogout, label = 'Kuestion' }) {
  return (
    <nav className="kqc-rail" aria-label={label}>
      <span className="kqc-rail__mark"><Mark /></span>
      <div className="kqc-rail__items">
        {items.map((n) => (
          <button
            key={n.key}
            type="button"
            className={`kqc-rail__btn${active === n.key ? ' is-active' : ''}`}
            title={n.title || n.label}
            aria-label={n.title || n.label}
            aria-current={active === n.key ? 'page' : undefined}
            data-tour={n.tour}
            onClick={() => onGo(n)}
          >
            <span className="kqc-rail__icon">{n.icon}</span>
            <span className="kqc-rail__label">{n.label}</span>
          </button>
        ))}
      </div>
      <span className="kqc-rail__spacer" />
      {/* The Knowledge Base is public and opens in its own tab, so a sitting or
          a half-filled form is never left behind to read a guide. */}
      <a className="kqc-rail__btn kqc-rail__btn--dim" href={kq('kb')} target="_blank" rel="noopener noreferrer" title="Knowledge base — opens in a new tab" aria-label="Knowledge base (opens in a new tab)">
        <span className="kqc-rail__icon"><BookIcon /></span>
        <span className="kqc-rail__label">Guides</span>
      </a>
      <TourBell />
      <button type="button" className="kqc-rail__btn kqc-rail__btn--dim" title="Log out" aria-label="Log out" onClick={onLogout}>
        <span className="kqc-rail__icon"><LogoutIcon /></span>
        <span className="kqc-rail__label">Log out</span>
      </button>
    </nav>
  );
}
